import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractChartOfAccountsValidationResult from "./AbstractChartOfAccountsValidationResult.js";

/**
 * Error raised when a mandatory group is missing in the chart of accounts.
 *
 * @param {string} spec.missingKey - Id of the missing group
 */
export default class MissingKeyValidationResult extends AbstractChartOfAccountsValidationResult {
	constructor(spec) {
		super(spec);

		this._missingKey = spec.missingKey;
	}

	getMissingKey() {
		return this._missingKey;
	}

	getMessage() {
		return _(
			'The mandatory known group "{name}" must be present in the chart.',
			{
				name: this._missingKey,
			},
		);
	}

	static getType() {
		return "MissingKeyValidationResult";
	}
}
